import { defineStore } from 'pinia';
import { ref } from 'vue';
import api from '@/common/utils/api';
import isSelfService from '@/common/utils/isSelfService';

export type LoginUrl = {
  id: string;
  url: string;
  name: string;
};

export const useIdpAuthStore = defineStore('idpAuth', () => {
  const loginUrls = ref<LoginUrl[]>([]);

  function resetState() {
    loginUrls.value = [];
  }

  async function fetchLoginUrls(domainName?: string) {
    let url = '/api/v2/login';
    if (isSelfService() && domainName) {
      url = `${url}?domain=${domainName}`;
    }

    try {
      const { data } = await api.get(url);
      loginUrls.value = data.idps;
      return data.idps;
    } catch (error) {
      console.error('Error fetching login URLs:', error);
      return [];
    }
  }

  return {
    loginUrls,
    resetState,
    fetchLoginUrls
  };
});

export default useIdpAuthStore;
